export default __webpack_public_path__ + "static/media/erode-salem.e70e980a.png";